import React from 'react';
import { Box } from '@mui/material';
import { ViewToggle } from '../../HomePage/HelperComponents';
import { colors } from '../../../constants/globalcss';

interface RequestFormToggleProps {
  useGrid: boolean;
  onToggle: (
    _event: React.MouseEvent<HTMLElement>,
    newValue: boolean | null
  ) => void;
}

const RequestFormToggle: React.FC<RequestFormToggleProps> = ({
  useGrid,
  onToggle,
}) => (
  <Box
    sx={{
      '& .MuiToggleButtonGroup-root': {
        boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',
      },
      '& .MuiToggleButtonGroup-root .MuiToggleButton-root': {
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: colors.primary,
            color: colors.background.paper,
          },
          backgroundColor: colors.primary,
          border: `1px solid ${colors.primary}`,
          borderRadius: '8px !important',
          color: colors.background.paper,
          fontWeight: 700,
        },
        '&:hover': {
          backgroundColor: '#e8eef7',
          color: colors.dark,
        },
        '&:not(:first-of-type)': {
          borderLeft: 'none',
        },
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '8px !important',
        color: '#375277',
        fontWeight: 600,
        minWidth: 88,
        px: 1.25,
        transition: 'background 0.2s, color 0.2s',
      },
    }}
  >
    <ViewToggle useGrid={useGrid} onToggle={onToggle} />
  </Box>
);

export default RequestFormToggle;
